export const GHOST_PREVIEW_OPACITY = 0.3;
